<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Assign Subject" @close="close()" />
      <v-card-text v-if="selectedCurriculum">
        <v-row>
          <v-col cols="12" sm="12">
            <!-- <div>
              Class:
              <span class="font-weight-bold text-capitalize">
                {{
                  selectedCurriculum.Class && selectedCurriculum.Class.name
                    ? selectedCurriculum.Class.name
                    : "N/A"
                }}
              </span>
            </div> -->

            <div>
              Curriculum Name:
              <span class="font-weight-bold text-capitalize">
                {{ selectedCurriculum.name || "N/A" }}
              </span>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <v-autocomplete
              dense
              autofocus
              hide-details
              :items="Subjects"
              clearable
              item-value="id"
              item-text="name"
              v-model="selectedSubject"
              return-object
              label="Select Subject"
              outlined
            >
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title
                    class="text--primary text-capitalize"
                    v-text="item.name"
                  >
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              outlined
              autofocus
              type="number"
              dense
              v-model="marks"
              label="Marks"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2">
            <v-btn
              @click="add"
              :disabled="!selectedSubject || !marks"
              color="success"
              >Add</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <div class="list-350">
          <draggable
            v-model="curriculumSubjectList"
            handle=".drag-handle"
            animation="150"
          >
            <div
              v-for="(row, index) in curriculumSubjectList"
              :key="row.id"
              class="d-flex align-center mb-2 pa-2 subject-row"
            >
              <!-- Drag handle -->
              <v-icon class="mr-2 drag-handle" color="grey darken-1">
                mdi-drag
              </v-icon>

              <!-- Subject name -->
              <div class="flex-grow-1">
                <div class="text-capitalize font-weight-medium">
                  {{ index + 1 }}. {{ row.name }}
                </div>
              </div>

              <!-- Marks -->
              <div style="width: 110px">
                <v-text-field
                  hide-details
                  outlined
                  type="number"
                  dense
                  v-model="row.marks"
                  label="Marks"
                ></v-text-field>
              </div>

              <!-- Delete -->
              <v-btn icon class="ml-2" @click="deleteRow(index)">
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </div>
          </draggable>

          <div class="d-flex align-center justify-end mt-4 font-weight-bold">
            Total Marks: {{ totalMarks }}
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="green lighten-1" :loading="loading" dark @click="submit()"
          >save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import curriculumService from "@/modules/ReportCard/Curriculums/service.js";
import subjectService from "@/modules/ReportCard/Subject/service.js";
import draggable from "vuedraggable";

export default {
  props: {
    editDialog: {
      default: false,
    },
    selectedCurriculum: {
      type: Object,
    },
  },
  name: "Assign-Class-to-student",
  data() {
    return {
      Subjects: [],
      selectedSubject: null,
      marks: 0,
      curriculumSubjectList: [],
      loading: false,
      dialog: false,
    };
  },
  components: {
    draggable,
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getSubject();
        if (
          this.selectedCurriculum &&
          this.selectedCurriculum.subjectMeta &&
          this.selectedCurriculum.subjectMeta.subjects
        ) {
          this.curriculumSubjectList = JSON.parse(
            JSON.stringify(this.selectedCurriculum.subjectMeta.subjects)
          );
        }
        console.log(
          "selectedCurriculum in assign subject",
          this.selectedCurriculum
        );
      }
    },
  },
  computed: {
    totalMarks() {
      let marks = 0;
      this.curriculumSubjectList.map((row) => {
        marks += parseInt(row.marks);
      });
      return marks;
    },
  },
  methods: {
    deleteRow(i) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.curriculumSubjectList.splice(i, 1);
        }
      });
    },
    add() {
      let subjectFound = false;
      this.curriculumSubjectList.map((row) => {
        if (row.id === this.selectedSubject.id) {
          subjectFound = true;
        }
      });
      if (subjectFound) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Subject already Assigned to this curriculum",
          });
        return true;
      }
      let obj = {
        id: this.selectedSubject.id,
        marks: this.marks,
        name: this.selectedSubject.name,
      };
      this.curriculumSubjectList.push(obj);
      this.selectedSubject = null;
      this.marks = null;
    },
    getSubject() {
      return subjectService.getAll().then((response) => {
        this.Subjects = response.data;
        console.log("response Subjects", this.Subjects);
        return response;
      });
    },
    submit() {
      if (this.totalMarks !== 100) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Total marks should be equal to 100",
          });
        return true;
      }
      // ✅ enforce order based on current drag position
      this.curriculumSubjectList = this.curriculumSubjectList.map(
        (row, idx) => ({
          ...row,
          order: idx + 1,
        })
      );

      this.selectedCurriculum.subjectMeta = {
        subjects: this.curriculumSubjectList,
      };

      curriculumService
        .update(this.selectedCurriculum.id, this.selectedCurriculum)
        .then((result) => {
          if (result) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Subjects assigned to this curriculum",
              });
            this.empty();
            this.$emit("submit");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
    close() {
      this.$emit("close");
      this.empty();
    },
    empty() {
      this.selectedSubject = null;
      this.marks = 0;
    },
  },
};
</script>

<style scoped>
.subject-row {
  border: 1px solid #eee;
  border-radius: 10px;
  background: white;
}

.drag-handle {
  cursor: grab;
}
</style>
